export default __webpack_public_path__ + "92c086f.png";